export const BLOG_IMAGE_FALLBACK = "/images/blog/generated/index.jpg";
export const BLOG_IMAGE_FALLBACK_PLACEHOLDER = "/images/blog/generated/index-placeholder.jpg";

const blogImageOverrides: Record<string, string> = {
  "oracle-training-consultants-new-website":
    "/images/brand/oracle-training-consultants-new-website-1200.webp",
  "sentinel-door-systems-new-website":
    "/images/brand/sentinel-door-systems-new-website-1200.webp",
};

const blogImagePlaceholderOverrides: Record<string, string> = {
  "oracle-training-consultants-new-website":
    "/images/brand/oracle-training-consultants-new-website-1200.webp",
  "sentinel-door-systems-new-website":
    "/images/brand/sentinel-door-systems-new-website-1200.webp",
};

const legacyGeneratedImageSlugs = new Set<string>([
  "ai-and-augmented-reality-in-search",
  "googles-2020-core-updates-and-their-impact",
  "hidden-gems-and-topic-authority",
  "mobilefirst-indexing-and-page-experience",
  "the-rise-of-core-web-vitals-and-page-experience",
  "user-experience-and-core-web-vitals-in-2022",
  "zeroclick-searches-and-data-analytics",
  "index",
]);

export const generatedBlogImageSlugs = new Set<string>([
  "july-2026-ai-search-what-small-businesses-should-do-now",
  "july-2026-google-core-update-recovery-playbook",
  "2023-seo-lessons-and-forward-view",

  "2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns",
  "a-practical-plan-for-ai-driven-search-a-ninety-day-playbook",
  "a-year-of-change-googles-2021-algorithm-updates",
  "ai-and-augmented-reality-in-search",
  "ai-in-search-the-rise-of-generative-experiences",
  "aligning-seo-with-revenue-goals-in-2025",
  "barnsley-seo-for-accountants-how-to-attract-higher-value-leads",
  "barnsley-seo-for-builders-how-to-turn-google-searches-into-quote-requests",
  "barnsley-seo-for-dental-and-health-clinics-local-patient-growth",
  "barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries",
  "bert-expansion-and-passage-indexing",
  "building-a-website-that-supports-seo-and-business-growth",
  "building-structured-data-and-schema-markup",
  "common-seo-mistakes-that-hold-small-businesses-back",
  "connecting-seo-to-revenue-in-an-ai-influenced-world-revision",
  "creating-an-seo-plan-that-supports-long-term-success",
  "data-driven-decisions-leveraging-ga4-for-seo-success",
  "decoding-googles-2022-algorithm-updates",
  "eat-and-the-evolution-of-content",
  "eeat-and-content-quality",
  "emerging-seo-specialties-aeo-geo-and-beyond",
  "enterprise-seo-and-collaboration",
  "firstparty-data-and-privacy",
  "generative-ai-and-content-creation-balancing-automation-and-authenticity",
  "generative-ais-role-in-search-in-2023",
  "googles-2020-core-updates-and-their-impact",
  "hidden-gems-and-topic-authority",
  "how-accountancy-websites-can-improve-enquiry-quality",
  "how-builders-can-get-more-quote-requests-from-google",
  "how-hairdressers-can-get-more-bookings-from-google",
  "how-law-firms-can-improve-search-led-enquiry-quality",
  "how-long-does-seo-take-in-barnsley-a-practical-timeline",
  "how-long-does-seo-take-in-sheffield-a-practical-timeline",
  "how-much-does-seo-cost-for-a-barnsley-business-in-2026",
  "how-much-does-seo-cost-for-a-wakefield-business-in-2026",
  "how-seo-builds-momentum-over-time-for-small-businesses",
  "how-to-hire-an-seo-consultant",
  "how-to-optimise-your-google-business-profile",
  "index",
  "indexnow-and-instant-indexing",
  "introduction-of-mum-and-passage-ranking",
  "january-2025-quiet-month-big-insights",
  "lessons-and-predictions-for-2022",
  "lessons-from-google-s-2025-algorithm-updates",
  "local-search-in-2025-personalisation-and-contextual-relevance",
  "local-seo-and-ai-optimising-for-voice-and-community",
  "local-seo-and-the-consumer-journey",
  "local-seo-enhancements-in-2023",
  "local-seo-for-accountancy-firms-what-matters-most",
  "local-seo-in-2022",
  "looking-ahead-lessons-from-2024-for-the-future",
  "mobile-and-core-web-vitals-in-2023",
  "mobilefirst-indexing-and-page-experience",
  "mobilefirst-indexing-gains-pace",
  "multi-format-content-and-diversified-channels",
  "navigating-googles-2023-core-and-spam-updates",
  "november-2025-digital-marketing-trends-to-watch",
  "omnichannel-and-social-search",
  "peoplefirst-content-vs-search-enginefirst",
  "preparing-for-2021-lessons-from-2020",
  "product-reviews-and-algorithm-updates",
  "protecting-against-spam-and-algorithmic-penalties",
  "private-dental-seo-treatment-pages-that-convert-patients",
  "quality-content-and-e-e-a-t-raising-the-bar-for-trust",
  "rethinking-seo-for-2025-putting-people-before-keywords",
  "salon-treatment-pages-that-improve-seo-performance",
  "search-in-a-pandemic-changing-user-behaviour",
  "seo-for-contractors-winning-higher-value-project-enquiries",
  "seo-for-electricians-emergency-versus-planned-search-intent",
  "seo-for-plumbers-emergency-boiler-and-bathroom-search-intent",
  "seo-in-2026-how-local-yorkshire-businesses-can-win-more-customers-from-google",
  "seo-in-an-ai-driven-search-world-what-small-businesses-need-to-focus-on",
  "seo-mistakes-that-cost-builders-local-leads",
  "seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026",
  "structured-data-and-rich-results",
  "tackling-zero-click-searches-turning-visibility-into-value",
  "the-advent-of-zeroclick-results",
  "the-rise-of-brand-seo-building-authority-for-2025",
  "the-rise-of-core-web-vitals-and-page-experience",
  "the-rise-of-the-helpful-content-update",
  "turning-website-visitors-into-customers-with-seo",
  "understanding-googles-latest-algorithm-update",
  "user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond",
  "user-experience-and-core-web-vitals-in-2022",
  "video-and-visual-search",
  "voice-and-conversational-search",
  "voice-search-and-conversational-content",
  "voice-search-and-conversational-queries-in-2023",
  "volatility-and-algorithm-resilience",
  "why-consistency-matters-more-than-quick-wins-in-seo",
  "why-seo-is-still-one-of-the-best-investments-for-growing-businesses",
  "why-seo-should-be-driving-your-business-growth-not-just-rankings",
  "why-seo-starts-with-your-website-and-always-will",
  "zeroclick-searches-and-data-analytics",
]);

export function getGeneratedBlogImage(slug: string): string {
  if (blogImageOverrides[slug]) return blogImageOverrides[slug];
  if (generatedBlogImageSlugs.has(slug) && !legacyGeneratedImageSlugs.has(slug)) {
    return `/images/brand/${slug}-1200.webp`;
  }
  return generatedBlogImageSlugs.has(slug)
    ? `/images/blog/generated/${slug}.jpg`
    : BLOG_IMAGE_FALLBACK;
}

export function getGeneratedBlogCardImage(slug: string): string {
  return getGeneratedBlogImage(slug);
}

export function getGeneratedBlogImagePlaceholder(slug: string): string {
  if (blogImagePlaceholderOverrides[slug]) return blogImagePlaceholderOverrides[slug];
  if (generatedBlogImageSlugs.has(slug) && !legacyGeneratedImageSlugs.has(slug)) {
    return `/images/brand/${slug}-1200.webp`;
  }
  return generatedBlogImageSlugs.has(slug)
    ? `/images/blog/generated/${slug}-placeholder.jpg`
    : BLOG_IMAGE_FALLBACK_PLACEHOLDER;
}
